<template>
  <v-autocomplete
    dense
    color="cyan"
    filled
    :id="id"
    :items="timeList"
    v-model="time"
    :placeholder="placeholder"
    solo
    flat
    item-color="cyan"
    hide-details
    v-on:change="emitValue()"
    :disabled="disabled"
  />
</template>

<script>
import moment from "moment-timezone";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "timepicker",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    id: {
      type: String,
      default: "start-time",
    },
    intervel: {
      type: Number,
      default: 60,
    },
    placeholder: {
      type: String,
      default: "Start Time",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: null,
    },
    minTime: {
      type: String,
      default: null,
    },
    disabledTimes: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    value: function () {
      this.init();
    },
    minTime: function () {
      this.emitValue();
      this.initTimeList();
    },
    disabledTimes: function () {
      this.initTimeList();
    },
  },
  data() {
    return {
      time: null,
      timeList: [],
    };
  },
  methods: {
    init() {
      this.time = this.value;
    },
    emitValue() {
      this.$emit("input", this.time);
      this.$emit("change", this.time);
    },
    initTimeList() {
      this.timeList = [];
      let startTime = moment().startOf("day");
      let endTime = moment().endOf("day");
      let minTime = this.minTime
        ? moment(`${moment().format("YYYY-MM-DD")} ${this.minTime}`)
        : null;

      while (startTime.isBefore(endTime)) {
        let value = startTime.format("hh:mm A");
        let isBeforeMin = minTime ? startTime.isBefore(minTime) : false;
        let isExcluded = this.disabledTimes.includes(value);

        this.timeList.push({
          text: value,
          value,
          disabled: isBeforeMin || isExcluded,
        });

        startTime.add(this.intervel, "minutes");
      }
    },
  },
  mounted() {
    this.init();
    this.initTimeList();
  },
};
</script>